import eHelpFramework from "./eHelpFramework" 
let qelpcare = new eHelpFramework({
    "selector" : ".main-application",
    "datalayer" : true
});
